// 사례개념화 탭별 작성 가이드. 피드백을 받기 전 오른쪽 패널에 보여준다.
export const caseGuides = {
    presenting: {
        tabLabel: '주 호소',
        focus: [
            '내담자가 직접 말한 어려움을 내담자의 표현에 가깝게 적어요.',
            '상담을 찾게 된 계기와 의뢰 경로가 있다면 함께 적어요.',
            '어려움이 언제부터, 얼마나 자주 나타나는지 확인한 만큼 적어요.',
        ],
        avoid: ['면담에서 확인하지 않은 내용을 진단명이나 성격 특성으로 단정하지 않아요.'],
        example: '퇴근 후 무기력과 자기비판이 반복됩니다. 생활을 바꾸고 싶지만 다시 실패할까 걱정합니다.',
    },
    changetalk: {
        tabLabel: '변화대화',
        focus: [
            '변화를 바라는 말(바람·능력·이유·필요·결단)을 따옴표로 그대로 옮겨요.',
            '지금 상태를 유지하려는 말(유지대화)도 함께 적어 양가감정을 보여줘요.',
            '두 말이 어떤 주제에서 부딪히는지 한 줄로 정리해요.',
        ],
        avoid: ['상담자의 해석만 적고 내담자의 실제 표현을 빠뜨리지 않아요.'],
        example: '“이러다 계속 제자리일 것 같아요.” / “예전에는 산책하면 좀 나았는데, 요즘은 시작하기도 어려워요.” 변화에 대한 바람과 시작의 어려움이 함께 나타납니다.',
    },
    risk: {
        tabLabel: '위험 신호',
        focus: [
            '자·타해, 학대·방임, 급성 위기와 관련된 언급이 있었는지 적어요.',
            '확인된 신호, 확인 결과 없음, 아직 확인하지 못함을 구분해요.',
            '판단의 근거가 된 발화가 있다면 함께 적어요.',
        ],
        avoid: ['묻지 않아 모르는 것을 \'없음\'으로 적지 않아요. 이때는 \'추가 확인 필요\'라고 적어요.'],
        example: '제시된 대화만으로는 자·타해 등 위험 관련 신호를 충분히 확인할 수 없습니다. 다음 면담에서 추가 확인이 필요합니다.',
    },
    plan: {
        tabLabel: '상담 목표',
        focus: [
            '내담자와 함께 합의할 수 있는 목표를 내담자의 말로 적어요.',
            '다음 면담에서 더 탐색할 내용을 구체적으로 적어요.',
            '위험 신호를 추가 확인해야 한다면 그 계획도 포함해요.',
        ],
        avoid: ['상담자가 정한 목표를 내담자에게 그대로 제시하는 방식은 피해요.'],
        example: '내담자가 원하는 일상을 구체화하고, 과거 도움이 된 경험과 스스로 선택할 수 있는 작은 행동을 탐색합니다.',
    },
};

// 전체 보기 탭에서 보여주는 연결 점검 가이드.
export const overviewGuide = {
    tabLabel: '전체 보기',
    focus: [
        '주 호소와 변화대화가 같은 주제를 이야기하고 있는지 확인해요.',
        '위험 신호에서 \'추가 확인 필요\'라고 적었다면 상담 목표에 확인 계획이 있는지 봐요.',
        '상담 목표가 변화대화에서 드러난 내담자의 바람과 이어지는지 확인해요.',
    ],
    avoid: ['항목끼리 서로 맞지 않는 내용이 있다면 그 항목으로 돌아가 고쳐요.'],
};
